import React from 'react'

export default function Extras() {
  return (
    <>
        <h1> Extras</h1>
        <p> This documents any extra styles or classes not listed in other components</p>

        <ul className='mb-items-1'>
        <li><span className='tag-grey bold'>.d-block</span> class - sets the display property to block</li>
        <li><span className='tag-grey bold'>.d-none</span> class - sets the display property to none</li>
        <li><span className='tag-grey bold'>.d-flex</span> class - sets the display property to flex</li>
        <li><span className='tag-grey bold'>.fl-column</span> class - sets the flex-direction to column</li>
        <li><span className='tag-grey bold'>.fl-row</span> class - sets the flex-direction to row</li>
        <li><span className='tag-grey bold'>.position-fixed</span> class - sets the position to fixed</li>
        <li><span className='tag-grey bold'>.position-sticky</span> class - sets the position to sticky</li>
        <li><span className='tag-grey bold'>.flex-align-xy</span> class - aligns the contents of an element vertically and horizontally using flex </li>
        </ul>
    </>
  )
}
